import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useClassName } from '../../../../hooks';
import { Icon, Space, Typography } from '../../../../components';
import { CollapsibleContext } from '../../Collapsible.context';
import { ToggleButton } from './components';
import { useOnClick } from './hooks';
import './Header.scss';
export const Header = () => {
    const { title, icon, isOpen, content, headerTestId } = useContext(CollapsibleContext);
    const className = useClassName({ name: 'collapsible-button', prefixed: true }, isOpen ? 'open' : 'closed', 'flex', 'items-center', 'justify-between', !!content && 'has-content');
    const onClick = useOnClick();
    return (_jsxs("div", { "data-testid": headerTestId, className: className, onClick: onClick, children: [_jsxs(Space, { size: 'sm', direction: 'horizontal', children: [icon && _jsx(Icon, { name: icon, color: 'primary-500', size: 'lg' }), _jsx(Typography.Text, { color: 'neutral-600', size: 'md', weight: 'medium', children: title })] }), _jsx(ToggleButton, {})] }));
};
